module.exports = __webpack_public_path__ + "img/61.0ff8937c.png";